import React from "react";

export default function Education() {
  const education = [
    { degree: "Master of Computer Applications (MCA)", institute: "Indira Gandhi National Open University, New Delhi", year: "2013", percentage: "62%" },
    { degree: "ITI", institute: "Jammu, India", year: "2011" },
    { degree: "Bachelor of Computer Applications (BCA)", institute: "Vinayaka Missions Research Foundation (VMRF), Tamil Nadu", year: "2007", percentage: "61%" },
    { degree: "Higher Secondary (10+2)", subjects: "Physics, Chemistry, Mathematics, English", board: "Jammu & Kashmir Board of School Education" }
  ];

  return (
    <section id="education">
      <h2>Education</h2>
      <div className="timeline">
        {education.map((edu, index) => (
          <div key={index} className={`timeline-item ${index % 2 === 0 ? "fade-left" : "fade-right"}`}>
            <h3>{edu.degree}</h3>
            <p>{edu.institute}</p>
            {edu.year && <p><strong>Year:</strong> {edu.year}</p>}
            {edu.subjects && <p><strong>Subjects:</strong> {edu.subjects}</p>}
            {edu.board && <p><strong>Board:</strong> {edu.board}</p>}
          </div>
        ))}
      </div>
    </section>
  );
}
